"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _r10SourceLibrary = require("r10-source-library");
var _react = _interopRequireDefault(require("react"));
var _services = require("../../services");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _constants = require("../../utils/constants");
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var StyledGridColumn = (0, _styledComponents.default)(_r10SourceLibrary.GridColumn)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: flex-end;\n"])));
var UpsellItem = function UpsellItem(_ref) {
  var productType = _ref.productType,
    title = _ref.title,
    price = _ref.price,
    selectedPrice = _ref.selectedPrice;
  var priceUpfrontValue, priceMonthlyValue, durationAmount, durationUnit;
  var setPayment = function setPayment(upfrontPrice, monthlyPrice, monthlyPeriod, monthlyUnit) {
    priceUpfrontValue = upfrontPrice;
    priceMonthlyValue = monthlyPrice;
    durationAmount = monthlyPeriod;
    durationUnit = monthlyUnit;
  };
  if (selectedPrice) {
    setPayment(selectedPrice.upfront, selectedPrice.monthlyPrice, selectedPrice.monthlyPeriod, selectedPrice.monthlyUnit);
  } else {
    setPayment(price.priceType === _constants.PRICE_TYPES.UP_FRONT ? price.priceValue : 0, price.priceType === _constants.PRICE_TYPES.UP_FRONT ? 0 : price.priceValue, price.durationAmount, price.durationUnit);
  }
  var ProductInformation = function ProductInformation() {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
      size: 2,
      weight: 3
    }, "".concat(_services.locale.localeString("RelationshipOffer.".concat(productType)), ":")))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
      size: 2
    }, title))), durationAmount && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
      size: 2
    }, "".concat(durationAmount, " ").concat(_services.locale.localeString("RelationshipOffer.".concat(durationUnit)), " ").concat(_services.locale.localeString("RelationshipOffer.".concat(productType)))))));
  };
  return /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 3,
      bottom: 3
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.SimpleGrid, {
    columns: {
      sm: 3
    },
    layout: {
      sm: [6, 3, 3]
    },
    spacing: 3
  }, /*#__PURE__*/_react.default.createElement(ProductInformation, null), /*#__PURE__*/_react.default.createElement(StyledGridColumn, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
    size: 2,
    weight: 3
  }, _services.locale.formatPrice(priceUpfrontValue))), /*#__PURE__*/_react.default.createElement(StyledGridColumn, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
    size: 2,
    weight: 3
  }, _services.locale.formatPrice(priceMonthlyValue)))));
};
var _default = UpsellItem;
exports.default = _default;